import { useContext } from 'react';

import { Icons, Button, mergeSx, SxProps } from '@cast/design-system';

import { RffInputsArrayContext } from './RffInputsArrayContext';

type Props = {
  testId?: string;
  text?: string;
  disabled?: boolean;
  sx?: SxProps;
};

export const AddRowButton = ({
  testId = 'add-row-btn',
  text = 'Add',
  disabled = false,
  sx,
}: Props) => {
  const arrayContext = useContext(RffInputsArrayContext);

  return (
    <Button
      className="InputsStack-AddRowButton"
      variant="text"
      startIcon={<Icons.Plus />}
      disabled={disabled}
      onClick={arrayContext.add}
      sx={mergeSx(
        {
          mt: 12,
        },
        sx
      )}
      testId={testId}
    >
      {text}
    </Button>
  );
};
